module.exports = __webpack_public_path__ + "img/tx.f41464d4.jpg";